import { Inject, Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoadingSpinnerService } from '../services/loading-spinner.service';
import { DISABLED_SPINNER_PATHS } from '../tokens/disabled-spinner-paths.token';
import { finalize } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { LocalStorageService } from '../services/local-storage.service';

@Injectable()
export class SpinnerInterceptor implements HttpInterceptor {
  private activeRequests = 0;

  constructor(
    @Inject(DISABLED_SPINNER_PATHS) private disabledSpinnerPaths: RegExp[],
    private spinnerService: LoadingSpinnerService,
    private localStorageService: LocalStorageService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const requestURL = request.url;
    const apiUrlLocalStorage = environment.ENVIRONMENT !== 'production' ? this.localStorageService.apiUrl : undefined;

    if (!requestURL.includes(apiUrlLocalStorage || environment.API_URL) || this.checkDisableSpinner(requestURL)) {
      return next.handle(request);
    }

    this.activeRequests++;
    if (this.activeRequests === 1) {
      this.spinnerService.showSpinner();
    }

    return next.handle(request).pipe(
      finalize(() => {
        this.activeRequests--;
        if (this.activeRequests === 0) {
          this.spinnerService.hideSpinner();
        }
      })
    );
  }

  checkDisableSpinner(requestURL: string): boolean {
    const urlPath = new URL(requestURL).pathname;

    return this.disabledSpinnerPaths.some((regexpPath) => regexpPath.test(urlPath));
  }
}
